var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 24,
    height: 24,
    transform: "translate(27 998)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tax1",
    transform: "translate(-27 -998)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taxes",
    transform: "translate(-5.019 1000.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11054",
    "data-name": "Path 11054",
    d: "M39.646,312H36.729a.729.729,0,1,0,0,1.458h.729v5.1a.729.729,0,1,0,1.458,0v-5.1h.729a.729.729,0,1,0,0-1.458Z",
    transform: "translate(0 -300.625)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    d: "M196,318.563a.729.729,0,1,0,1.458,0v-2.187h1.458v2.188a.729.729,0,1,0,1.458,0v-4.375a2.188,2.188,0,1,0-4.375,0Zm2.188-5.1a.73.73,0,0,1,.729.729v.729h-1.458v-.729A.73.73,0,0,1,198.188,313.458Z",
    transform: "translate(-154.167 -300.625)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11056",
    "data-name": "Path 11056",
    d: "M356.4,319.21a.729.729,0,0,0,.978-.326l.806-1.612.806,1.612a.729.729,0,0,0,1.3-.652l-1.3-2.591,1.3-2.591a.729.729,0,1,0-1.3-.652l-.806,1.612-.806-1.612a.729.729,0,1,0-1.3.652l1.3,2.591-1.3,2.591A.729.729,0,0,0,356.4,319.21Z",
    transform: "translate(-308.329 -300.62)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11057",
    "data-name": "Path 11057",
    d: "M89.125,2.188A2.19,2.19,0,0,0,86.938,0H81.1A5.1,5.1,0,0,0,76,5.1V9.479a.729.729,0,0,0,1.458,0V6.563a.73.73,0,0,1,.729-.729h1.458a2.19,2.19,0,0,0,2.188-2.188V2.188a.73.73,0,0,1,.729-.729h4.375a.73.73,0,0,1,.729.729V9.479a.729.729,0,0,0,1.458,0Zm-8.75,0V3.646a.73.73,0,0,1-.729.729H78.188a2.179,2.179,0,0,0-.676.107,3.656,3.656,0,0,1,2.97-2.97A2.179,2.179,0,0,0,80.375,2.188Z",
    transform: "translate(-38.542)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11058",
    "data-name": "Path 11058",
    d: "M156,240.729a.729.729,0,0,0,.729.729h5.833a.729.729,0,0,0,0-1.458h-5.833A.729.729,0,0,0,156,240.729Z",
    transform: "translate(-115.625 -231.25)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11059",
    "data-name": "Path 11059",
    d: "M258.917,161.458a.729.729,0,0,0,0-1.458h-2.187a.729.729,0,1,0,0,1.458Z",
    transform: "translate(-211.979 -154.167)",
    fill: "#9e9e9e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIcon);
export default __webpack_public_path__ + "static/media/Tax_Icon.c349fcb970e3f0a46468019cf6243aca.svg";
export { ForwardRef as ReactComponent };